import { render, staticRenderFns } from "./ExcludedList.vue?vue&type=template&id=fc991c66&scoped=true&lang=html&"
import script from "./ExcludedList.vue?vue&type=script&lang=js&"
export * from "./ExcludedList.vue?vue&type=script&lang=js&"
import style0 from "./ExcludedList.vue?vue&type=style&index=0&id=fc991c66&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc991c66",
  null
  
)

export default component.exports